import BaseApi from './base'

class KitUpdatePers extends BaseApi {
  getListKitUpdatePers = (query) =>
    this.client.get(`pers-update-campaigns?${query}`)

  getDetailKitUpdatePers = (id) =>
    this.client.get(`pers-update-campaigns/${id}`)

  addKitUpdatePers = (data) => this.client.post('pers-update-campaigns', data)

  updateKitUpdatePers = ({ campaignId, payload }) =>
    this.client.patch(`pers-update-campaigns/${campaignId}`, payload)

  deleteKitUpdatePers = (id) =>
    this.client.delete(`pers-update-campaigns/${id}`)

  transitionKitUpdatePers = ({ campaignId, state }) =>
    this.client.patch(`pers-update-campaigns/${campaignId}/state`, { state })

  attachKitUpdatePersTargets = ({ campaignId, nuSerialPersNumbers }) =>
    this.client.post(`pers-update-campaigns/${campaignId}/targets`, {
      nuSerialPersNumbers
    })

  detachKitUpdatePersTarget = ({ campaignId, targetId }) =>
    this.client.delete(
      `pers-update-campaigns/${campaignId}/targets/${targetId}`
    )

  bulkDetachKitUpdatePersTargets = ({ campaignId, targetIds }) =>
    this.client.post(`pers-update-campaigns/${campaignId}/targets/remove`, {
      targetIds
    })

  // Same route as the PERS list (getPers in ./per.js), read on its own so the
  // picker never touches the shared PERS list state.
  // The route lives in `business` (fleet host), not on the backoffice host the
  // client defaults to, so only this call overrides the base URL.
  searchKitUpdatePersPickerPers = (query) =>
    this.client.get(`pers?${query}`, {
      baseURL: `${this.fleetURL}/backoffice`
    })
}

export default new KitUpdatePers()
